import React, { useState } from "react";
import { Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Image } from "../../../../AbstractElements";
import { SMSData } from "../types/types";
import { dynamicImage } from "../../../../service";

interface RecipientModalProps {
  isOpen: boolean;
  toggle: () => void;
  recipients: string[];
}

const RecipientModal: React.FC<RecipientModalProps> = ({
  isOpen,
  toggle,
  recipients,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>All Recipients</ModalHeader>
      <ModalBody>
        <ul className="simple-list p-0">
          {recipients.map((recipient: string, index: number) => (
            <li key={index} className="d-flex align-items-center gap-3 mb-3">
              <Image
                className="img-fluid rounded-circle"
                src={dynamicImage(`dashboard-8/user${(index % 3) + 1}.png`)}
                alt={`${recipient} avatar`}
                style={{ width: "40px", height: "40px" }}
              />
              <span className="fw-medium">{recipient}</span>
            </li>
          ))}
        </ul>
      </ModalBody>
    </Modal>
  );
};

interface SentSMSContentProps {
  data: SMSData;
  i: number;
}

const SentSMSContent: React.FC<SentSMSContentProps> = ({ data, i }) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const { recipientRoles } = data;
  const recipientCount = recipientRoles.length;

  const renderRecipientNames = () => {
    if (recipientCount > 2) {
      return `${recipientRoles.slice(0, 2).join(", ")}...`;
    }
    return recipientRoles.join(", ");
  };

  const overlapStyle: React.CSSProperties = {
    width: "35px",
    height: "35px",
    marginLeft: "-15px",
    border: "2px solid #F7F8F9",
    zIndex: 1,
  };

  return (
    <>
      <div className="inbox-user d-flex align-items-center gap-3">
        <div className="form-check form-check-inline m-0">
          <Input
            className={`checkbox-${data.priority?.[0]?.color || "secondary"}`}
            name="smsCheckbox"
            id={`smsCheckbox${i}`}
            type="checkbox"
          />
          <Label check for={`smsCheckbox${i}`} />
        </div>

        <div
          className="d-flex align-items-center"
          style={{ cursor: "pointer", minWidth: "65px" }}
          onClick={toggle}
        >
          {recipientCount > 0 && (
            <div
              className="rounded-circle overflow-hidden"
              style={{
                width: "40px",
                height: "40px",
                border: "2px solid #F7F8F9",
                zIndex: 2,
              }}
            >
              <Image
                className="img-fluid rounded-circle"
                src={dynamicImage("dashboard-8/user1.png")}
                alt={recipientRoles[0]}
              />
            </div>
          )}

          {recipientCount === 2 && (
            <div
              className="rounded-circle overflow-hidden"
              style={overlapStyle}
            >
              <Image
                className="img-fluid rounded-circle"
                src={dynamicImage("dashboard-8/user2.png")}
                alt={recipientRoles[1]}
              />
            </div>
          )}

          {recipientCount > 2 && (
            <div
              className="d-flex align-items-center justify-content-center rounded-circle bg-secondary"
              style={overlapStyle}
            >
              <span>+{recipientCount - 1}</span>
            </div>
          )}
        </div>

        <p className="mb-0" style={{ cursor: "pointer" }} onClick={toggle}>
          {renderRecipientNames()}
        </p>
      </div>
      <div className="inbox-message">
        <div className="email-data">
          <span>{data.description && <span>{data.description}</span>}</span>
        </div>
        <div className="email-timing">
          <span>{data.time}</span>
        </div>
        <div className="email-options">
          <i className="fa fa-trash-o trash-3" />
        </div>
      </div>
      <RecipientModal
        isOpen={modal}
        toggle={toggle}
        recipients={recipientRoles}
      />
    </>
  );
};

export default SentSMSContent;
